export default __webpack_public_path__ + "static/media/Slide-4.0ac5eb5e.jpg";